import { render, staticRenderFns } from "./DrugChargeDetails.vue?vue&type=template&id=e6552d44"
import script from "./DrugChargeDetails.vue?vue&type=script&lang=js"
export * from "./DrugChargeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports